// extracted by mini-css-extract-plugin
export default {"btnExpander":"TextExpander_btnExpander__Y3Ezy"};